<template>
  <div class="columns">
    <div class="sideText" v-if="changingMyself"> 
      <h4>{{ $t('selectUser.join') }}</h4>
      <h5>
      {{ $t('selectUser.sideText') }}
      </h5>
      <router-link to="/info/linking-account/" class="infoLink"><font-awesome-icon class="info" icon="info-circle" /> {{ $t('selectUser.moreInfo') }}</router-link>
    </div>

    <div class="container" >
      <div class="extraSpace" v-if="changingMyself"></div>
      <div class="header"> 
        <div class="closeButton">
          <button class="btn theme-close-button" @click="cancel">
            <font-awesome-icon icon="times" />
          </button>
        </div>
        <h2 v-if="changingMyself">{{ $t('selectUser.selectYourself') }}</h2>
        <h2 v-if="!changingMyself">account koppelen aan KNSB lid</h2>
        <p v-if="!changingMyself"> de speler '{{targetChessUser.name}}' kan hier worden gekoppeld aan een KNSB registratie</p>
      </div>
      <div class="fieldsContainer">
        <div class="inputFields">
          <label>{{ $t('selectUser.filterClub') }}</label>
          <Multiselect
            v-model="selectedClub"
            placeholder="selecteer een club"
            label="name" 
            valueProp="clubId"
            trackBy="name"
            @search-change="loadClubs"
            :options="clubs"
            :filterResults="false"
            :searchable="true"
          />

          <label>{{ $t('selectUser.player') }}</label>
          <input type="text" v-model.lazy="personSearchString" v-debounce="1000" :placeholder="$t('persons.search')">
          <div v-if="isPersonsLoading" class="spincontainer">
            <font-awesome-icon icon="cog" class="fa-spinner fa-spin icon" /> loading...
          </div>

          <persons-list v-if="persons != null" 
              :persons="persons" 
              :listType="'SelectFederationOriginal'"
              :optionSelectAll="false"
              v-on:personListChanged="personListChanged"></persons-list>

          <div v-if="errorMessage" class="w3-panel errorBox w3-round">
            {{ errorMessage }} 
            <font-awesome-icon icon="exclamation-circle" class="errorIcon w3-right"/>
          </div>

          <div class="buttonContainer">
            <div class="link" v-if="changingMyself">
              <br/>
              <router-link to="/" class="specialLink">{{ $t('selectUser.noMember') }}</router-link>
            </div>
            <div class="flex"> 
              <button v-if="changingMyself" :class="{'button-inactive': !onePersonSelected, 'button-default': onePersonSelected }" @click="selectPerson">{{ $t('selectUser.thisIsMe') }}</button>
              <button v-if="!changingMyself" :class="{'button-inactive': !onePersonSelected, 'button-default': onePersonSelected }" @click="selectPerson">{{ $t('selectUser.link') }}</button>
            </div>  
          </div>
        </div>

      </div>
    </div>
    <div class="dummySpace" v-if="changingMyself"></div>
    <div class="bottomLogo"  v-if="changingMyself"><h4>Chess Administrator</h4></div>
  </div>
</template>

<script>
import {RestAPI} from "@aws-amplify/api-rest";
import PersonsList from "@/components/players/PersonsList";
import Multiselect from '@vueform/multiselect';

const apiName = 'api';
const myInit = { 
  response: false, 
};


export default {
  name: 'SelectUser',
  props:{ 
    personId: String
  },
  components: {Multiselect, PersonsList},
  data: function () {
    return {
      awaitingPersonSearch: false,
      clubs: [],
      errorMessage: "",
      persons: [],    // Used for search
      personsLoading: false,
      personSearchString: "",
      personsToBeAdded: [], // Person ID's as selected in de PersonList
      selectedClub: "",
      targetChessUser: {name:""}
    }
  },
  emits: [ 'cancel', 'ok' ],
  beforeMount() {
    this.determineTargetChessUser();
  },
  computed: {
    changingMyself() {
      return (this.personId == null);
    },
    isPersonsLoading() {
      return this.personsLoading;
    },
    onePersonSelected() {
      return (this.personsToBeAdded.length == 1);
    }
  },
  updated: function () {
    this.$nextTick(function () {
      this.loading=false;
    })
  },
  watch: {
    personSearchString: function () {
      this.loadPersons();
    },
    selectedClub: function(oldVal, newVal) {
      if (oldVal != newVal) {
        this.loadPersons();
      }
    }
  },
  methods: {
    cancel: function() {
      this.$emit('cancel');
      this.$router.go("-1");
    },
    
    determineTargetChessUser() {
      //determines which CA user we will use to impersonate another federation user.
      if (this.personId != null) {
        this.loadTargetChessUser(this.personId);
      } else {
        this.targetChessUser = this.$CAUser.getChessUser();
      }
    },

    home() {
      this.$router.push('/')
    },

    loadClubs: function(query) {
      if (query != "") {
        let that = this
        let fullPath = "/club/?name=" + query;
        RestAPI
          .get(apiName, fullPath, myInit)
          .then(response => {
            that.clubs = response;
            return JSON.stringify(that.clubs);
          })
          .catch(error => {
            console.log(error.response);
          });
      }
    },

    loadTargetChessUser: function(personId) {
      let that = this
      let path = '/person/' + personId;
      RestAPI
        .get(apiName, path, myInit)
        .then(response => {
          console.log("setting target chess user: " + JSON.stringify(response));
          that.targetChessUser = response;
        })
        .catch(error => {
          if (error.status !== 404) {
            console.log("ERROR", JSON.stringify(error));
          }
        });
    },   

    loadPersons() {
      let that = this
      if (this.personSearchString != "" || this.selectedClub != null) {
        this.personsLoading = true;
        let fullPath = "/person";
        if (this.selectedClub != "" && this.selectedClub != null) {
          console.log(this.selectedClub);
          if (this.personSearchString != "" )
            fullPath = fullPath + "?clubId=" + this.selectedClub + "&name=" + encodeURIComponent(this.personSearchString);
          else
            fullPath = fullPath + "?clubId=" + this.selectedClub;
        } else
          fullPath = fullPath + "?name=" + encodeURIComponent(this.personSearchString);
        console.log("fullpath: " + fullPath)
        RestAPI
          .get(apiName, fullPath, myInit)
          .then(response => {
            that.persons = response
            that.personsLoading = false;
          })
          .catch(error => {
            console.log(error.response);
          });
      } else {
        this.persons = null;
      }
    },

    personListChanged: function(newVal) {
      console.log("geselecteerd: " + newVal);
      //store the personID's selected in the PersonList.
      //After an OK, we will save according to this list
      //In this case, the array can only contain one element.
      this.personsToBeAdded = newVal;
    },

    selectPerson: function() {
      if (this.personsToBeAdded.length == 1) {
        var selectedPerson = this.persons.filter((item) => {
          return (item.personId == this.personsToBeAdded[0]);
        })

        console.log("Setting Chess User in selectPerson to: " + JSON.stringify(selectedPerson[0]));

        const myInit = { 
          headers: { 'Authorization': 'Bearer '+ this.$CAUser.getToken()},
          body: this.targetChessUser,
          response: false, 
        };

        let that = this;

        var completePath = "/person/" + selectedPerson[0].personId + "/impersonate";
        console.log("Using token: " + this.$CAUser.getToken());
        RestAPI
          .post(apiName, completePath, myInit)
          .then(response => {
            console.log("Impersonation succesful." + JSON.stringify(response))
            if (this.changingMyself) {
              this.$CAUser.setChessUser(response);
            }
            that.$emit("ok");
            this.$router.go("-1");
          })            
          .catch(error => {
            this.confirmationError = false;
            switch(error.response.data.message) {
              case "Impersonation Failed":
                this.errorMessage = this.$t("selectUser.impersonationFailed");
                break;
              default:
                this.errorMessage = error.response.data.message;
                console.log("ERROR", JSON.stringify(error));
            }
          });
      }
    }
  }
}

</script>


<style scoped>

.buttons {
  display: flex;
  flex-direction: row-reverse;
}

.imgbtn {
    transition: border .3s linear, color .3s linear, background-color .3s linear;
}
.imgbtn:hover {
    color: #5681c2;
}

.info {
  color: #f5d997;
}

.link {
  margin-top: 1em;
}

.multiselect {
  margin-bottom: 8px;
}
.sideText {
  color: white;
  padding: 1vw;
}

/* mobile */
@media screen and (max-width: 600px) {
  .columns {
    display: flex;
    flex-direction: column;
    width: 90vw;
  }

  header {
    font-size: 5vw;
    padding: 0vw 2vw;
  }

  .content {
    padding: 0vw 2vw;
  }
}

/* ipad */
@media screen and (min-width: 601px) and (max-width: 1280px) {
  .AddUserLink {
    max-width: 60vw;
  }

  .columns {
    display: flex;
    flex-direction: column;
    margin: auto;
  }

  header {
    font-size: 1.5vw;
    padding: 0vw 1vw;
  }

  .content {
    padding: 0vw 1vw;
  }

  .dummySpace {
    width: 300px;
  }

  .inactive .button-default {
    background-color: #555;
  }

  .sideText {
    width: 300px;
    margin-top: 12vh;
  }
}

/* laptop */
@media screen and (min-width: 1281px) {
  .AddUserLink {
    max-width: 50vw;
  }

  .columns {
    display: flex;
    flex-direction: row;
    margin: auto;
  }
  
  header {
    font-size: 1.5vw;
    padding: 0vw 1vw;
  }

  .container {
    width: 500px;
  }

  .extraSpace {
    margin-top: 10vh;
  }

  .dummySpace {
    width: 350px;
  }

  .sideText {
    width: 350px;
    margin-top: 12vh;
  }
}
</style>
